import { render, staticRenderFns } from "./ContactLeftPanel.vue?vue&type=template&id=bfb2388c&scoped=true&"
import script from "./ContactLeftPanel.vue?vue&type=script&lang=ts&"
export * from "./ContactLeftPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2388c",
  null
  
)

export default component.exports